var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("validation-observer", {
    ref: "formAddCampaign",
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function (ref) {
          var invalid = ref.invalid
          return [
            _c(
              "b-form",
              {
                on: {
                  submit: function ($event) {
                    $event.preventDefault()
                    return _vm.formSubmitted($event)
                  },
                },
              },
              [
                _vm.mainLoading
                  ? _c(
                      "div",
                      { staticClass: "d-flex justify-content-center mb-1" },
                      [
                        _c("b-spinner", {
                          staticStyle: { width: "3rem", height: "3rem" },
                          attrs: {
                            variant: "success",
                            label: "Spinning",
                            block: "",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                !_vm.mainLoading
                  ? _c(
                      "b-row",
                      [
                        _c(
                          "b-col",
                          { attrs: { md: "6" } },
                          [
                            _c(
                              "b-form-group",
                              {
                                attrs: {
                                  label: "Campaign Name",
                                  "label-for": "campaign_name",
                                },
                              },
                              [
                                _c("validation-provider", {
                                  attrs: {
                                    rules: "required",
                                    name: "campaign name",
                                    vid: "Campaign Name",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (ref) {
                                          var errors = ref.errors
                                          return [
                                            _c("b-form-select", {
                                              attrs: {
                                                options: _vm.campaignOptions,
                                                state:
                                                  errors.length > 0
                                                    ? false
                                                    : null,
                                              },
                                              model: {
                                                value: _vm.campaignName,
                                                callback: function ($$v) {
                                                  _vm.campaignName = $$v
                                                },
                                                expression: "campaignName",
                                              },
                                            }),
                                            _c(
                                              "small",
                                              { staticClass: "text-danger" },
                                              [_vm._v(_vm._s(errors[0]))]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "b-col",
                          { attrs: { md: "6" } },
                          [
                            _c(
                              "b-form-group",
                              {
                                attrs: {
                                  label: "Start Date",
                                  "label-for": "start_date",
                                },
                              },
                              [
                                _c("validation-provider", {
                                  attrs: {
                                    rules: "required",
                                    name: "start date",
                                    vid: "Start Date",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (ref) {
                                          var errors = ref.errors
                                          return [
                                            _c("b-form-datepicker", {
                                              attrs: {
                                                id: "start_date",
                                                placeholder: "Choose a date",
                                                local: "en",
                                                state:
                                                  errors.length > 0
                                                    ? false
                                                    : null,
                                                "initial-date": new Date(),
                                              },
                                              model: {
                                                value: _vm.startDate,
                                                callback: function ($$v) {
                                                  _vm.startDate = $$v
                                                },
                                                expression: "startDate",
                                              },
                                            }),
                                            _c(
                                              "small",
                                              { staticClass: "text-danger" },
                                              [_vm._v(_vm._s(errors[0]))]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "b-col",
                          { attrs: { md: "6" } },
                          [
                            _c(
                              "b-form-group",
                              {
                                attrs: {
                                  label: "End Date",
                                  "label-for": "end_date",
                                },
                              },
                              [
                                _c("validation-provider", {
                                  attrs: {
                                    rules: "required",
                                    name: "end date",
                                    vid: "End Date",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (ref) {
                                          var errors = ref.errors
                                          return [
                                            _c("b-form-datepicker", {
                                              attrs: {
                                                id: "end_date",
                                                placeholder: "Choose a date",
                                                local: "en",
                                                state:
                                                  errors.length > 0
                                                    ? false
                                                    : null,
                                                "initial-date": _vm.startDate,
                                                min: _vm.startDate,
                                              },
                                              model: {
                                                value: _vm.endDate,
                                                callback: function ($$v) {
                                                  _vm.endDate = $$v
                                                },
                                                expression: "endDate",
                                              },
                                            }),
                                            _c(
                                              "small",
                                              { staticClass: "text-danger" },
                                              [_vm._v(_vm._s(errors[0]))]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "b-col",
                          { attrs: { md: "6" } },
                          [
                            _c(
                              "b-form-group",
                              {
                                attrs: {
                                  label: "Email Template",
                                  "label-for": "email_template",
                                },
                              },
                              [
                                _c("validation-provider", {
                                  attrs: {
                                    rules: "required",
                                    name: "email template",
                                    vid: "Email Template",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (ref) {
                                          var errors = ref.errors
                                          return [
                                            _c("b-form-select", {
                                              attrs: {
                                                options: _vm.emailtemplatelist,
                                                state:
                                                  errors.length > 0
                                                    ? false
                                                    : null,
                                              },
                                              on: {
                                                change: _vm.selectTemplate,
                                              },
                                              model: {
                                                value: _vm.selectedTemplateId,
                                                callback: function ($$v) {
                                                  _vm.selectedTemplateId = $$v
                                                },
                                                expression:
                                                  "selectedTemplateId",
                                              },
                                            }),
                                            _c(
                                              "small",
                                              { staticClass: "text-danger" },
                                              [_vm._v(_vm._s(errors[0]))]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "b-col",
                          { attrs: { md: "6" } },
                          [
                            _c(
                              "b-form-group",
                              {
                                attrs: {
                                  label: "SMTP Setting",
                                  "label-for": "email_smtp",
                                },
                              },
                              [
                                _c("validation-provider", {
                                  attrs: {
                                    rules: "required",
                                    name: "SMPT setting",
                                    vid: "SMPT Setting",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (ref) {
                                          var errors = ref.errors
                                          return [
                                            _c("b-form-select", {
                                              attrs: {
                                                state:
                                                  errors.length > 0
                                                    ? false
                                                    : null,
                                                options: _vm.smtp,
                                              },
                                              model: {
                                                value: _vm.selectedProvider,
                                                callback: function ($$v) {
                                                  _vm.selectedProvider = $$v
                                                },
                                                expression: "selectedProvider",
                                              },
                                            }),
                                            _c(
                                              "small",
                                              { staticClass: "text-danger" },
                                              [_vm._v(_vm._s(errors[0]))]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "b-col",
                          { attrs: { md: "6" } },
                          [
                            _c(
                              "b-form-group",
                              {
                                attrs: {
                                  label: "Segment",
                                  "label-for": "segment",
                                },
                              },
                              [
                                _c("validation-provider", {
                                  attrs: {
                                    rules: "required",
                                    name: "segment",
                                    vid: "Segment",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (ref) {
                                          var errors = ref.errors
                                          return [
                                            _c("v-select", {
                                              staticClass:
                                                "item-selector-title",
                                              attrs: {
                                                options: _vm.segmentOptions,
                                                label: "itemTitle",
                                                multiple: "",
                                                clearable: false,
                                                placeholder: "Select Item",
                                                state:
                                                  errors.length > 0
                                                    ? false
                                                    : null,
                                              },
                                              model: {
                                                value: _vm.selectedSegments,
                                                callback: function ($$v) {
                                                  _vm.selectedSegments = $$v
                                                },
                                                expression: "selectedSegments",
                                              },
                                            }),
                                            _c(
                                              "small",
                                              { staticClass: "text-danger" },
                                              [_vm._v(_vm._s(errors[0]))]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "b-col",
                          { attrs: { md: "12" } },
                          [
                            _c(
                              "b-form-group",
                              {
                                attrs: {
                                  label: "Subject",
                                  "label-for": "subject",
                                },
                              },
                              [
                                _c("validation-provider", {
                                  attrs: {
                                    rules: "required",
                                    name: "subject",
                                    vid: "Subject",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (ref) {
                                          var errors = ref.errors
                                          return [
                                            _c("b-form-input", {
                                              attrs: {
                                                placeholder: "Subject",
                                                name: "subject",
                                                state:
                                                  errors.length > 0
                                                    ? false
                                                    : null,
                                              },
                                              model: {
                                                value:
                                                  _vm.selectedTemplate.subject,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.selectedTemplate,
                                                    "subject",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "selectedTemplate.subject",
                                              },
                                            }),
                                            _c(
                                              "small",
                                              { staticClass: "text-danger" },
                                              [_vm._v(_vm._s(errors[0]))]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "b-col",
                          { attrs: { md: "12" } },
                          [
                            _c(
                              "b-form-group",
                              {
                                attrs: {
                                  label: "Email Content",
                                  "label-for": "email_content",
                                },
                              },
                              [
                                _c("validation-provider", {
                                  attrs: {
                                    rules: "required",
                                    name: "email content",
                                    vid: "Email Content",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (ref) {
                                          var errors = ref.errors
                                          return [
                                            _c("quill-editor", {
                                              attrs: {
                                                state:
                                                  errors.length > 0
                                                    ? false
                                                    : null,
                                              },
                                              model: {
                                                value:
                                                  _vm.selectedTemplate.body,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.selectedTemplate,
                                                    "body",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "selectedTemplate.body",
                                              },
                                            }),
                                            _c(
                                              "small",
                                              { staticClass: "text-danger" },
                                              [_vm._v(_vm._s(errors[0]))]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c("b-col", { attrs: { md: "12" } }, [
                          _c(
                            "div",
                            { staticClass: "demo-inline-spacing" },
                            [
                              _c(
                                "b-form-radio",
                                {
                                  attrs: { name: "radio1", value: "D" },
                                  model: {
                                    value: _vm.SelectedRadio,
                                    callback: function ($$v) {
                                      _vm.SelectedRadio = $$v
                                    },
                                    expression: "SelectedRadio",
                                  },
                                },
                                [_vm._v(" Save as Draft ")]
                              ),
                              _c(
                                "b-form-radio",
                                {
                                  attrs: { name: "radio1", value: "A" },
                                  model: {
                                    value: _vm.SelectedRadio,
                                    callback: function ($$v) {
                                      _vm.SelectedRadio = $$v
                                    },
                                    expression: "SelectedRadio",
                                  },
                                },
                                [_vm._v(" Send Now ")]
                              ),
                              _c(
                                "b-form-radio",
                                {
                                  attrs: { name: "radio1", value: "B" },
                                  model: {
                                    value: _vm.SelectedRadio,
                                    callback: function ($$v) {
                                      _vm.SelectedRadio = $$v
                                    },
                                    expression: "SelectedRadio",
                                  },
                                },
                                [_vm._v(" Schedule Sending ")]
                              ),
                            ],
                            1
                          ),
                        ]),
                        _vm.SelectedRadio === "B"
                          ? _c(
                              "b-col",
                              { staticClass: "mt-2", attrs: { md: "12" } },
                              [
                                _c(
                                  "b-form-group",
                                  [
                                    _c("validation-provider", {
                                      attrs: {
                                        rules: "required",
                                        name: "date and time",
                                        vid: "dateNtim",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (ref) {
                                              var errors = ref.errors
                                              return [
                                                _c("h5", [
                                                  _vm._v("Date & Time"),
                                                ]),
                                                _c("b-form-datepicker", {
                                                  attrs: {
                                                    id: "form-control",
                                                    placeholder:
                                                      "Choose a date",
                                                    local: "en",
                                                    "initial-date": new Date(),
                                                    min: _vm.today,
                                                    state:
                                                      errors.length > 0
                                                        ? false
                                                        : null,
                                                  },
                                                  model: {
                                                    value: _vm.dateNtim,
                                                    callback: function ($$v) {
                                                      _vm.dateNtim = $$v
                                                    },
                                                    expression: "dateNtim",
                                                  },
                                                }),
                                                _c(
                                                  "small",
                                                  {
                                                    staticClass: "text-danger",
                                                  },
                                                  [_vm._v(_vm._s(errors[0]))]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _c("b-col", { attrs: { md: "12" } }, [
                          _c(
                            "div",
                            { staticClass: "demo-inline-spacing" },
                            [
                              _vm.showSaveDraft
                                ? _c(
                                    "b-button",
                                    {
                                      directives: [
                                        {
                                          name: "ripple",
                                          rawName: "v-ripple.400",
                                          value: "rgba(255, 255, 255, 0.15)",
                                          expression:
                                            "'rgba(255, 255, 255, 0.15)'",
                                          modifiers: { 400: true },
                                        },
                                      ],
                                      attrs: { variant: "warning" },
                                      on: { click: _vm.saveDraft },
                                    },
                                    [_vm._v(" Save as Draft ")]
                                  )
                                : _vm._e(),
                              _vm.showSaveScheduled
                                ? _c(
                                    "b-button",
                                    {
                                      directives: [
                                        {
                                          name: "ripple",
                                          rawName: "v-ripple.400",
                                          value: "rgba(255, 255, 255, 0.15)",
                                          expression:
                                            "'rgba(255, 255, 255, 0.15)'",
                                          modifiers: { 400: true },
                                        },
                                      ],
                                      attrs: { variant: "info" },
                                      on: { click: _vm.saveScheduled },
                                    },
                                    [_vm._v(" Schedule ")]
                                  )
                                : _vm._e(),
                              _vm.showSendNow
                                ? _c(
                                    "b-button",
                                    {
                                      directives: [
                                        {
                                          name: "ripple",
                                          rawName: "v-ripple.400",
                                          value: "rgba(255, 255, 255, 0.15)",
                                          expression:
                                            "'rgba(255, 255, 255, 0.15)'",
                                          modifiers: { 400: true },
                                        },
                                      ],
                                      attrs: { variant: "success" },
                                      on: { click: _vm.sendNow },
                                    },
                                    [_vm._v(" Send Now ")]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ]),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              1
            ),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }